import module from './module.js'
// Components
import './components/component.js'
import './components/cuentacontable/component.js'
import './components/deudoresdiversos/component.js'
import './components/deudoresdiversosegresos/component.js'
import './components/exportar/component.js'
import './components/facturacion/component.js'
import './components/facturacion/lista/component.js'
import './components/facturacion/lista/cliente/component.js'
import './components/facturacion/lista/empresa/component.js'
import './components/facturascanceladas/component.js'
import './components/facturascanceladas/lista/component.js'
import './components/nodeducibles/component.js'
import './components/operadorasempresas/component.js'
import './components/pagosnominasmxn/component.js'
import './components/pagosnominasusd/component.js'
import './components/provisiongastos/component.js'
import './components/provisiongastospagos/component.js'
import './components/provisioningresospagos/component.js'
import './components/provisioningresospagos/lista/component.js'
import './components/provisioningresospagos/lista/cliente/component.js'
import './components/provisionnomina/component.js'
import './components/provisionnominaconpagos/component.js'
import './components/provisionnominaconpagos/lista/component.js'
import './components/provisionnominaconpagossucursales/component.js'
import './components/provisionnominaconpagossucursales/lista/component.js'
import './components/provisionnominalnf/component.js'
// Services
import './services/Polizas.js'
import './services/ContabilidadPolizasFacturascanceladas.js'
import './services/ContabilidadPolizasProvisionnominaconpagos.js'
import './services/ContabilidadPolizasProvisionnominaconpagosSucursales.js'
import './services/deudoresDiversosEgresosService.js'
import './services/Polizas/DeudoresDiversos.js'
import './services/exportarService.js'
import './services/facturacionService.js'
import './services/noDeduciblesService.js'
import './services/pagosNominasMXNService.js'
import './services/pagosNominasUSDService.js'
import './services/provisionGastosPagosService.js'
import './services/ProvisionGastosService.js'
import './services/provisionIngresosPagos.js'
import './services/provisionNominaLNFService.js'
import './services/provisionNominaService.js'
// Routes
import './routes/contabilidad-polizas-facturascanceladas.js'
import './routes/contabilidad-polizas-provisionnominasconpagos.js'
import './routes/contabilidad-polizas-provisionnominasconpagossucursales.js'
import './routes/polizas/deudoresDiversos.js'
import './routes/polizas/provisionIngresosPagos.js'
import './routes/polizas/provisionGastosPagos.js'
import './routes/polizas.js'

export default module.name



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/index.js